import { AdmittedSessionPanel } from '../../components/custodian/AdmittedSessionPanel';

export function CustodyExplorerPage() {
  return (
    <div className="page-stack">
      <AdmittedSessionPanel />
    </div>
  );
}
